import { useTenantMap } from '../../data/useTenants';
import { useT } from '../../i18n/I18nProvider';

/**
 * The last crumb on `/tenants/:id`.
 *
 * The trail used to end in eight characters of the organisation's GUID, so the
 * one line of the header that tells you where you are was the one line you
 * could not read. The name comes from the tenants list the console already
 * caches; until it lands, and for an id that is not in it, the crumb says
 * "Details", which is at least true.
 */
export function TenantCrumb({ id }: { id: string }) {
  const t = useT();
  const { map } = useTenantMap();
  const name = map.get(id)?.name;
  return <>{name ?? t('shell.breadcrumb.details')}</>;
}
